
/**
 * 获取商品类型
 * @returns 
 */
export async function getGoodCategories() {
  return await $axios.get('/api/good/categories')
}

/**
 * 获取商品列表
 * @returns 
 */
export async function getGoodList() {
  return await $axios.get('/api/good/list')
}

/**
 * 获取简单的商品列表
 * @returns 
 */
export async function getSimpleGood(id?: string) {
  return await $axios.get<SimpleGood[]>('/api/good/simple' + (id ? `/${id}` : ''))
}

/**
 * 删除商品
 * @param data
 * @returns 
 */
export async function removeGood(data: any) {
  return await $axios.put('/api/good/remove', data)
}

/**
 * 上架/下架商品
 * @param data
 * @returns 
 */
export async function updateStatus(data: any) {
  return await $axios.put('/api/good/updateStatus', data)
}

/**
 * 更改商品排序码
 * @param data
 * @returns 
 */
export async function updateSort(data: any) {
  return await $axios.put('/api/good/sort', data)
}

/**
 * 创建/修改商品
 * @param data 
 * @returns 
 */
export async function createGood(data: any) {
  return await $axios.post('/api/good/createOrUpdate', data)
}

/**
 * 复制商品
 * @param data 
 * @returns 
 */
export async function copyGood(data: any) {
  return await $axios.post('/api/good/copy', data)
}

/**
 * 获取商户的所有商品类型
 * @returns 
 */
export async function getCategory(id: string) {
  return await $axios.get<DataDic[]>('/api/good/category/' + id)
}

/**
 * 批量修改商品分类
 * @param data
 * @returns 
 */
export async function updateGoodCategory(data: any) {
  return await $axios.put('/api/good/updateGoodCategory', data)
}

/**
 * 获取物料信息
 * @returns 
 */
export async function getMaterials() {
  return await $axios.get('/api/good/materials')
}

/**
 * 获取库存
 * @returns 
 */
export async function getStocks(date: string) {
  return await $axios.get<GoodStockDto>('/api/good/stocks/' + date)
}

/**
 * 更新库存
 * @returns 
 */
export async function updateStock(date: string, data: any) {
  return await $axios.post<GoodStockDto>('/api/good/updateStock/' + date, data)
}

/**
 * 删除库存
 * @returns 
 */
export async function removeStock(date: string, data: any) {
  return await $axios.post<GoodStockDto>('/api/good/removeStock/' + date, data)
}

/**
 * 复制库存
 * @returns 
 */
export async function copyStock(data: any) {
  return await $axios.post('/api/good/copyStock', data)
}

/**
 * 获取平台商品列表
 * @param source 来源：JingdongMapping-京东 yilianyun-易联云
 * @returns 
 */
export async function getPlatformGoods(source: string) {
  return await $axios.get<PlatformGoodDto[]>('/api/platform/goods/' + source)
}